import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import { Grid } from '@xceedsrl/jukebox';
import { measures } from '../config/constants';
import Input from '../components/Input';
import GenderInput from '../components/GenderInput';
import PhoneInput from '../components/PhoneInput';
import CountryInput from '../components/CountryInput';
function TicketBuyer(_ref) {
  var fields = _ref.fields,
    formik = _ref.formik,
    _ref$disabledBuyerFie = _ref.disabledBuyerFields,
    disabledBuyerFields = _ref$disabledBuyerFie === void 0 ? [] : _ref$disabledBuyerFie;
  var _useState = useState(false),
    isAutoFillPhone = _useState[0],
    setIsAutofillPhone = _useState[1];
  var handleAutoFillPhone = function handleAutoFillPhone(fieldName, phone) {
    formik.setFieldValue(fieldName, phone, true);
    setIsAutofillPhone(true);
  };
  var handleChangePhone = function handleChangePhone(fieldName, phone) {
    formik.setFieldValue(fieldName, phone, true);
    setIsAutofillPhone(false);
  };
  var _handleChange = function handleChange(fieldName, event) {
    formik.setFieldValue(fieldName, event.target.value, true);
  };
  return React.createElement(Grid, {
    gridGap: 16,
    gridTemplateColumns: measures.GRID_COLUMNS,
    paddingY: 2
  }, fields.map(function (field) {
    var isFieldDisabled = disabledBuyerFields.includes(field.slug);
    if (field.slug.includes('gender')) {
      return React.createElement(GenderInput, _extends({
        key: field.slug,
        name: field.slug,
        dataType: field.dataType,
        displayName: field.name,
        required: field.isRequired,
        handleBlur: formik.handleBlur,
        handleChange: function handleChange(v) {
          formik.setFieldValue(field.slug, v, true);
        },
        disabled: isFieldDisabled
      }, formik.getFieldMeta(field.slug)));
    }
    if (field.slug.includes('phone')) {
      return React.createElement(PhoneInput, _extends({
        key: field.slug,
        name: field.slug,
        dataType: field.dataType,
        displayName: field.name,
        required: field.isRequired,
        handleBlur: formik.handleBlur,
        handleChange: function handleChange(value) {
          return handleChangePhone(field.slug, value);
        },
        onAutoFill: function onAutoFill(value) {
          return handleAutoFillPhone(field.slug, value);
        },
        disabled: isFieldDisabled,
        isAutoFill: isAutoFillPhone
      }, formik.getFieldMeta(field.slug)));
    }
    if (field.slug.includes('nationality')) {
      return React.createElement(CountryInput, _extends({
        key: field.slug,
        name: field.slug,
        dataType: field.dataType,
        displayName: field.name,
        required: field.isRequired,
        handleBlur: formik.handleBlur,
        handleChange: function handleChange(v) {
          formik.setFieldValue(field.slug, v, true);
        },
        disabled: isFieldDisabled
      }, formik.getFieldMeta(field.slug)));
    }
    return React.createElement(Input, _extends({
      key: field.slug,
      name: field.slug,
      dataType: field.dataType,
      displayName: field.name,
      required: field.isRequired,
      handleBlur: formik.handleBlur,
      handleChange: function handleChange(event) {
        return _handleChange(field.slug, event);
      },
      disabled: isFieldDisabled
    }, formik.getFieldMeta(field.slug)));
  }));
}
export default TicketBuyer;